module.exports = __webpack_public_path__ + "static/media/assets.7bf80272.gif";